import { BaseModel } from "./base";

export class TenderCategory extends BaseModel{
    id: string;
    categoryName: string;
    _id: string;
  }